import { PageLoaderInner } from './pageloader-inner';
import { PageLoaderPortal } from './pageloader-portal';

type PageLoaderProps = {
  show?: boolean;
  progress?: number;
};

const PageLoader = (props: PageLoaderProps) => (
  <PageLoaderPortal>
    <PageLoaderInner {...props} />
  </PageLoaderPortal>
);

PageLoader.displayName = 'PageLoader';
export { PageLoader };
